export default __webpack_public_path__ + "static/media/app-explain-app-view.ff6fda8b.png";